
if (!Object.hasOwn) {
  Object.hasOwn = function (obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

if (typeof globalThis === "undefined") {
  Object.defineProperty(Object.prototype, "globalThis", {
    get: function () {
      return this;
    },
    configurable: true,
  });
}
